import { render, staticRenderFns } from "./DishesList.vue?vue&type=template&id=2f896d64&scoped=true&"
import script from "./DishesList.vue?vue&type=script&lang=js&"
export * from "./DishesList.vue?vue&type=script&lang=js&"
import style0 from "./DishesList.vue?vue&type=style&index=0&id=2f896d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f896d64",
  null
  
)

export default component.exports